"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./CTASection.scss");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = _interopRequireDefault(require("../Button/Button"));
var _CTASectionMethods = require("./CTASectionMethods");
var _ButtonAndCTAMethods = require("../../utils/methods/ButtonAndCTAMethods");
var _LunaLink = _interopRequireDefault(require("../LunaLink/LunaLink"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const CTASection = props => {
  const [ctaDirection, setCtaDirection] = (0, _react.useState)("column");
  const [btnClassNameForDirection, setBtnClassNameForDirection] = (0, _react.useState)("ter-button--secondary--1");
  const {
    ctaOne,
    ctaTwo,
    subCTA,
    direction,
    Link,
    VideoComponent
  } = props.ctas;
  (0, _react.useEffect)(() => {
    if (direction) {
      setCtaDirection((0, _CTASectionMethods.renderStyleDirection)(direction));
    }
    if (direction && ctaTwo?.className) {
      setBtnClassNameForDirection((0, _CTASectionMethods.renderClassNameForRow)(direction, ctaTwo?.className));
    }
  }, [props]);
  if (!ctaOne?.text && !ctaTwo?.text) {
    return null;
  } else {
    return /*#__PURE__*/_react.default.createElement("section", {
      className: `ter-cta-section  ter-cta-section--${ctaDirection}`,
      "data-sb-field-path": "ctaButtons"
    }, ctaOne?.text && /*#__PURE__*/_react.default.createElement(_Button.default, {
      contentfulId: ctaOne?.contentfulId,
      className: (0, _ButtonAndCTAMethods.formatClassName)(ctaOne?.className) || "ter-button--primary--1",
      text: ctaOne?.text,
      url: ctaOne?.url,
      onClick: ctaOne?.onClick,
      external: ctaOne?.external,
      Link: Link,
      size: ctaOne?.size,
      video: ctaOne?.video ? ctaOne?.video : null,
      setOverride: ctaOne?.setOverride,
      override: ctaOne?.override,
      VideoComponent: VideoComponent ? VideoComponent : null,
      setVideoProgress: ctaOne?.setVideoProgress,
      videoProgress: ctaOne?.videoProgress
    }), ctaTwo?.text && /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: btnClassNameForDirection,
      contentfulId: ctaTwo?.contentfulId,
      text: ctaTwo?.text,
      url: ctaTwo?.url,
      onClick: ctaTwo?.onClick,
      external: ctaTwo?.external,
      Link: Link,
      size: ctaTwo?.size,
      video: ctaTwo?.video ? ctaTwo?.video : null,
      setOverride: ctaTwo?.setOverride,
      override: ctaTwo?.override,
      setVideoProgress: ctaTwo?.setVideoProgress,
      videoProgress: ctaTwo?.videoProgress,
      VideoComponent: VideoComponent ? VideoComponent : null
    }), subCTA && (0, _CTASectionMethods.checkForExternalLink)(subCTA.url) && /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
      href: subCTA?.url,
      className: "ter-cta-section__link ter-sub-cta",
      target: subCTA?.external === false ? "_self" : "_blank",
      Link: Link && Link
    }, subCTA?.text));
  }
};
var _default = CTASection;
exports.default = _default;
CTASection.propTypes = {
  ctaOne: _propTypes.default.shape({
    text: _propTypes.default.string.isRequired,
    className: _propTypes.default.string,
    url: _propTypes.default.string,
    onClick: _propTypes.default.func
  }),
  ctaTwo: _propTypes.default.shape({
    text: _propTypes.default.string.isRequired,
    className: _propTypes.default.string,
    url: _propTypes.default.string,
    onClick: _propTypes.default.func
  }),
  subCTA: _propTypes.default.shape({
    text: _propTypes.default.string.isRequired,
    url: _propTypes.default.string.isRequired
  })
};